import React, { useState, forwardRef, useContext } from 'react';
import cn from 'clsx';
import { string, bool, func } from 'prop-types';
import FormContext from '../../context/FormContext.js';
import FormGroupContext from '../../context/FormGroupContext.js';

/**
 * FormToggle component.
 */

const FormToggle = /*#__PURE__*/forwardRef(({
  name,
  leftLabel,
  rightLabel,
  className,
  defaultChecked,
  onClick,
  onChange
}, ref) => {
  const {
    inputId
  } = useContext(FormGroupContext);
  const {
    inverted,
    onChange: onFormChange,
    defaultValues
  } = useContext(FormContext);
  const handleChange = evt => {
    if (onChange) {
      onChange(evt);
    }
    if (onFormChange) {
      onFormChange(evt);
    }
  };
  const [checked, setChecked] = useState(defaultChecked || (defaultValues === null || defaultValues === void 0 ? void 0 : defaultValues[name]));
  const handleClick = evt => {
    setChecked(evt.target.checked);
    if (onClick) {
      onClick();
    }
  };
  return /*#__PURE__*/React.createElement("div", {
    className: cn('form-toggle', className, inverted && 'form-toggle--inverted')
  }, leftLabel && /*#__PURE__*/React.createElement("span", {
    className: "form-toggle__label form-toggle__label--left" + (!checked ? " form-toggle__label--checked" : ""),
    "data-text": leftLabel
  }, leftLabel), /*#__PURE__*/React.createElement("input", {
    className: 'form-toggle__input' + (checked ? " form-toggle__input--checked" : ""),
    type: "checkbox",
    role: "switch",
    "aria-checked": !!checked,
    defaultChecked: checked,
    onClick: handleClick,
    id: inputId,
    ref: ref,
    onChange: handleChange,
    name: name
  }), rightLabel && /*#__PURE__*/React.createElement("span", {
    className: "form-toggle__label form-toggle__label--right" + (checked ? " form-toggle__label--checked" : ""),
    "data-text": rightLabel
  }, rightLabel));
});
FormToggle.displayName = 'FormToggle';
FormToggle.defaultProps = {
  leftLabel: null,
  rightLabel: null,
  className: null,
  defaultChecked: false,
  onClick: null,
  onChange: null
};
FormToggle.propTypes = process.env.NODE_ENV !== "production" ? {
  /** The input name. */
  name: string.isRequired,
  /** The left label */
  leftLabel: string,
  /** The right label */
  rightLabel: string,
  /** Additional class names */
  className: string,
  /** Is the toggle checked? */
  defaultChecked: bool,
  /** onClick method */
  onClick: func,
  /** onChange method */
  onChange: func
} : {};
export default FormToggle;